import { render } from "./Shared.vue?vue&type=template&id=0437d804"
import script from "./Shared.vue?vue&type=script&lang=js"
export * from "./Shared.vue?vue&type=script&lang=js"
script.render = render

export default script